import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/** @type {React.FC<React.PropsWithChildren<{href: string;}>>} */
const SkipLink = props => {
    return (
        <a
            className='link-reset skip-link type-style-5'
            href={props.href}>
            {props.children}
        </a>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default SkipLink;
